module.exports = __webpack_public_path__ + "img/img2.e958715e.png";